import { fonts, spacing } from "@softmax/design-system/tokens.stylex";
import * as stylex from "@stylexjs/stylex";

export const credentialDialogStyles = stylex.create({
  actions: {
    display: "flex",
    gap: spacing.space12,
    justifyContent: "flex-end",
    flexWrap: "wrap",
  },
  token: {
    fontFamily: fonts.mono,
    overflowWrap: "anywhere",
    whiteSpace: "pre-wrap",
    margin: 0,
    userSelect: "all",
  },
});
